module.exports = __webpack_public_path__ + "img/agentstudio-scene-1.55595d94.jpg";